import { render, staticRenderFns } from "./pi-button.vue?vue&type=template&id=aa9dd52e&"
import script from "./pi-button.vue?vue&type=script&lang=ts&"
export * from "./pi-button.vue?vue&type=script&lang=ts&"
import style0 from "./pi-button.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports